<template>
    <div class="wizard-cta">
        <div
            class="wizard-cta__wrap tw-flex tw-justify-between tw-items-center tw-py-4 tw-px-6 lg:tw-px-8 lg:tw-container tw-mx-auto"
        >
            <div v-if="price" class="lg:tw-flex lg:tw-items-end lg:tw-gap-4">
                <h6 class="body-sm">
                    {{ $t('configuration-wizard.pricing-from') }}
                </h6>
                <div class="wizard-cta__price-container tw-flex tw-items-baseline">
                    <h4
                        class="wizard-cta__price tw-text-lg lg:tw-text-2xl tw-leading-base lg:tw-leading-lg tw-text-basic tw-font-bold"
                    >
                        {{ price }}*
                    </h4>
                    <span v-if="priceDisclaimer" class="wizard-cta__price-disclaimer micro">
                        {{ priceDisclaimer }}
                    </span>
                </div>
            </div>
            <dk-button
                class="tw-min-w-[148px] lg:tw-min-w-[216px]"
                variant="accent"
                :disabled="isButtonDisabled"
                @click="onClick"
            >
                {{ $t('configuration-wizard.continue') }}
            </dk-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WizardCta',
    components: {
        DkButton: () => ({
            component: import(/* webpackChunkName: "DkButton-vue" */ '@v4/common/components/atoms/DkButton'),
        }),
    },
    props: {
        /**
         * The selected version
         */
        selectedVersion: {
            type: Object,
            default: () => ({}),
        },
        currentTab: {
            type: String,
            default: '',
        },
        selectedDealer: {
            type: Object,
            default: () => ({}),
        },
        price: {
            type: String,
            required: true,
        },
    },
    computed: {
        priceDisclaimer() {
            const version = this.selectedVersion || {};
            return version.pricing && (version.pricing.priceSuffix || '');
        },
        isButtonDisabled() {
            return this.currentTab === 'configuration-wizard__dealers' && !this.selectedDealer;
        },
    },
    methods: {
        onClick() {
            /**
             * Fired when clicked on the continue button
             *
             * @event click
             * @type {object}
             */
            this.$emit('continue-btn-click');
        },
    },
};
</script>
